import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface LibraryCategoriesState {
  data: [] | null | any;
  currentPage: number | null;
  totalRecords: number | null;
  totalPages: number | null;
  allLibraryCategories: [] | null | any;
}

const initialState: LibraryCategoriesState = {
  data: null,
  totalRecords: null,
  totalPages: null,
  currentPage: null,
  allLibraryCategories: null,
};

export const libraryCategoriesSlice = createSlice({
  name: 'LibraryCategories',
  initialState,
  reducers: {
    setLibraryCategories: (state, action) => {
      state.data = action.payload.data.content;
      state.totalRecords = action.payload.data.totalElements;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.number;
    },
    setAllLibraryCategories: (state, action) => {
      state.allLibraryCategories = action.payload;
    },
    setLibraryCategoriesBySearch: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.currentPage;
    },
    reset: (state) => {
      state = initialState;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setLibraryCategories, setLibraryCategoriesBySearch, setAllLibraryCategories, reset } = libraryCategoriesSlice.actions;
export const getLibraryCategoriesDetails = (state: RootState) => state.libraryCategories.data;
export const getAllLibraryCategoriesDetails = (state: RootState) => state.libraryCategories.allLibraryCategories;
export const getLibraryCategoriesBySearchDetails = (state: RootState) => state.libraryCategories.data;
export const getLibraryCategoriesTotalRecords = (state: RootState) => state.libraryCategories.totalRecords;
export default libraryCategoriesSlice.reducer;